export default __webpack_public_path__ + "static/media/2.e4b69066.jpeg";